<template>
  <mtdm-pullrefresh v-model="isLoading" @refresh="onRefresh">
    <div class="record-container">
      <div class="card-container">
        <div class="card-item" v-for="(item,index) in file_out_apply_list">
          <div class="card-header" @click="expand(index)">
            <div class="header-text">
              <div class="card-icon" v-if="item.isClick">
                <mtd-icon name='up-thick'></mtd-icon>
              </div>
              <div class="card-icon" v-else>
                <mtd-icon name='down-thick'></mtd-icon>
              </div>
              <div class="record-id">{{ item.id }}</div>
              <div class="file-names">{{ item.fileNames | fileNamesFilter }}</div>
              <div class="record-status">
                <mtd-tag theme="blue" type="pure" v-if="item.status === 0" class="approving">{{ $getText('ws_mobile_status_approving', '审批中') }}</mtd-tag>
                <mtd-tag theme="green" type="pure" v-if="item.status === 1" class="pass">{{ $getText('ws_mobile_status_approved', '已通过') }}</mtd-tag>
                <mtd-tag theme="red" type="pure" v-if="item.status === 2" class="rejected">{{ $getText('ws_mobile_status_rejected', '已驳回') }}</mtd-tag>
              </div>
            </div>
            <div class="header-time">
              <span>{{ $getText('ws_mobile_apply_time', '申请时间：') }}{{ item.createTime | dateFormat }} </span>
              <mtd-button type="text-primary" size="small" style="float: right" @click="copy(item, $event)"
                          v-if="item.status === 1 && !item.outOfDate">
                {{ $getText('ws_mobile_copy_share_link', '复制外发链接') }}
                <mtd-icon name='copy-o'/>
              </mtd-button>
              <mtd-button type="text-primary" size="small" style="float: right" @click="renew_record(item, $event)"
                          v-if="item.status === 1 && item.outOfDate">
                {{ $getText('ws_mobile_renew', '续期') }}
              </mtd-button>
            </div>
          </div>
          <div class="record-detail" v-if="item.isClick">
            <mtd-form>
              <mtd-form-item :label="$getText('ws_mobile_file_count', '文件数量')" :label-width="70">
                {{ $getText('ws_mobile_file_count_unit', {count: item.fileNum}, '{count}个文件') }}
              </mtd-form-item>
              <mtd-form-item :label="$getText('ws_mobile_send_out_process', '外发流程')" :label-width="70">
                {{ item.strategyName || $getText('ws_mobile_no_approval_required', '免审批') }}
              </mtd-form-item>
              <mtd-form-item :label="$getText('ws_mobile_send_out_reason', '外发原因')" :label-width="70">
                {{ item.reason || $getText('ws_mobile_none', '无') }}
              </mtd-form-item>
              <mtd-form-item :label="$getText('ws_mobile_send_out_email', '外发邮箱')" :label-width="70">
                {{ item.emails || $getText('ws_mobile_none', '无') }}
              </mtd-form-item>
            </mtd-form>
          </div>
          <div class="approval-btn" @click.stop="check_process(index)">
            <mtd-button style="padding-left: 0" type="text-primary">{{ $getText('ws_mobile_approval_progress', '审批进度') }}</mtd-button>
            <div style="float: right;font-size: 20px">
              <mtd-icon name='right-thick'></mtd-icon>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%;"
           v-if="file_out_apply_list.length !== search_form.total">
        <mtdm-button type="text-primary" width="full" size="tiny" @click="loadMore"
                     style="color: rgba(0, 0, 0, 0.24);" :loading="loading">
          {{ $getText('ws_mobile_load_more', '点击加载更多') }}
        </mtdm-button>
      </div>

      <!-- 选择有效期 -->
      <mtdm-slide-modal v-model="validate_days_modal" :title="$getText('ws_mobile_set_validity_period', '设置有效期')">
        <div class="validate_days_content">
          <mtd-radio-group v-model="renew_record_data.validateDays" @input="validateDays_change">
            <mtd-radio :value="3" @click="validateDays_click">3{{ $getText('ws_mobile_days', '天') }}</mtd-radio>
            <mtd-radio :value="7" @click="validateDays_click">7{{ $getText('ws_mobile_days', '天') }}</mtd-radio>
            <mtd-radio :value="30" @click="validateDays_click">30{{ $getText('ws_mobile_days', '天') }}</mtd-radio>
            <mtd-radio :value="-1">
              <span>{{ $getText('ws_mobile_custom_expiry_date', '自定义到期日') }}</span><br/>
              <span class="custom-tips">{{ $getText('ws_mobile_custom_expiry_tips', '可设定30天内任意日期') }}</span>
            </mtd-radio>
          </mtd-radio-group>
        </div>
      </mtdm-slide-modal>
      <!-- 自定义有效期 -->
      <mtdm-scrollpicker v-model="custom_validate_modal" :options="select_number" :value="custom_validate_days"
                         @cancel="close_custom_validate" @confirm="submit_custom_validate"
                         :confirm-text="$getText('ws_mobile_confirm', '确定')" nodeKey="value"/>


    </div>
  </mtdm-pullrefresh>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";

export default {
  name: "mobile_file_out_list",
  data() {
    const validateCustomDays = (_rule, value, callback) => {
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error(this.$getText('ws_mobile_validity_range_error', '最长有效期为30天，请输入1-30以内的数字')));
      }
      if (value < 1 || value > 30) {
        return callback(new Error(this.$getText('ws_mobile_validity_range_error', '最长有效期为30天，请输入1-30以内的数字')));
      }
      return callback();
    }
    return {
      isLoading: false,

      default_days: [
        {value: 3, label: '3' + this.$getText('ws_mobile_days', '天')},
        {value: 7, label: '7' + this.$getText('ws_mobile_days', '天')},
        {value: 30, label: '30' + this.$getText('ws_mobile_days', '天')}
      ],
      activeCard: 1,
      file_out_apply_list: [],
      search_form: {
        keyword: '',
        currentPage: 1,
        limit: 10,
        total: 0,
      },
      loading: false,
      outLinkAndPass: '',
      renew_record_data: {
        id: null,
        validateDays: 3
      },
      validate_days_modal: false,
      custom_validate_days: [3],
      custom_validate_modal: false,
      custom_validate_rule: {
        custom_validate: [
          {validator: validateCustomDays, trigger: 'change'},
        ]
      },
    }
  },
  filters: {
    fileNamesFilter(fileNames) {
      return fileNames.join(",");
    },
    dateFormat(date) {
      return moment(date)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 修改标题
    document.title = this.$getText('ws_mobile_application_history', '申请历史');

    this.select_record_list();
  },
  computed: {
    select_number() {
      let result = []
      for (let i = 1; i <= 30; i++) {
        result.push({label: i, value: i});
      }
      return result;
    }
  },
  methods: {
    ...mapActions([
      'queryFileOutRecordList',
      'queryApprovalDetails',
      'submitRenewFileOutOrder'
    ]),
    onRefresh() {
      this.isLoading = true;
      this.select_record_list();
    },
    copy(item, e) {
      if (e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
      }
      let vm = this;
      let message = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + item.downloadUrl + '\n' + this.$getText('ws_mobile_file_share_password_text', '文件分享密码：') + item.downloadPassword;
      vm.$copyText(message).then(function (_e) {
        vm.$mtdm.toast({
          message: this.$getText('ws_mobile_copy_success', '复制成功'),
          icon: 'mtdmicon-success-circle',
          duration: 2000
        });
      }, function (_e) {
        vm.$mtdm.toast({
          message: this.$getText('ws_mobile_copy_failed', '复制失败'),
          icon: 'mtdmicon-error-circle',
          duration: 2000
        });
      });
    },
    loadMore() {
      this.loading = true;
      this.search_form.currentPage += 1;
      this.queryFileOutRecordList(this.search_form).then(res => {
        let temp = res.data.items;
        for (let i = 0; i < temp.length; i++) {
          temp[i].isClick = false;
        }
        this.file_out_apply_list = this.file_out_apply_list.concat(temp);
      }).finally(() => {
        this.loading = false;
      });
    },
    expand(index) {
      let flag = this.file_out_apply_list[index].isClick;
      this.$set(this.file_out_apply_list[index], 'isClick', !flag);
    },
    select_record_list() {
      this.queryFileOutRecordList(this.search_form).then(res => {
        let temp = res.data.items;
        this.search_form.currentPage = res.data.currentPage;
        this.search_form.total = res.data.total;
        for (let i = 0; i < temp.length; i++) {
          temp[i].isClick = false;
        }
        this.file_out_apply_list = temp;
        this.isLoading = false;
      })
    },
    copySuccess() {
      this.$mtd.message({
        message: this.$getText('ws_mobile_copy_success_to_clipborad', '链接已复制到剪切板'),
        type: 'success',
      });
    },
    copyError() {
      this.$mtd.message({
        message: this.$getText('ws_mobile_copy_failed', '复制失败'),
        type: 'error',
      });
    },
    check_process(index) {
      let id = this.file_out_apply_list[index].id;
      this.queryApprovalDetails({id: id}).then(res => {
        if (res.code === 0) {
          this.$router.push({
            name: 'mobile_file|outer|file_out_progress',
            params: {record: res.data, approvalList: res.approvalList}
          });
        } else {
          this.$mtdm.toast({
            message: this.$getText('ws_mobile_query_failed', '查询失败'),
            icon: 'mtdmicon-error-circle',
            duration: 2000
          });
        }
      });
    },
    renew_record(row, e) {
      if (e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
      }
      this.renew_record_data.id = row.id;
      this.validate_days_modal = true;
    },
    validateDays_change(val) {
      if (val === -1) {
        this.custom_validate_modal = true;
      } else {
        this.custom_validate_modal = false;
        this.validate_days_modal = false;
        // 提交
        this.submit_renew_recorde();
      }
    },
    validateDays_click() {
      if (this.renew_record_data.validateDays !== -1) {
        this.custom_validate_modal = false;
        this.validate_days_modal = false;
        // 提交
        this.submit_renew_recorde();
      }
    },
    close_custom_validate() {
      this.custom_validate_modal = false;
      this.custom_validate_days = [3];
      this.renew_record_data.validateDays = 3;
    },
    submit_custom_validate(values) {
      if (values.length === 0) {
        return;
      }
      this.renew_record_data.validateDays = values[0];
      this.custom_validate_modal = false;
      this.validate_days_modal = false;
      this.custom_validate_days = [3];
      this.submit_renew_recorde();
    },
    submit_renew_recorde() {
      this.submitRenewFileOutOrder(this.renew_record_data).then(_res => {
        this.$mtdm.toast({
          message: this.$getText('ws_mobile_renew_success', '申请续期成功'),
          icon: 'mtdmicon-success-circle',
          duration: 2000
        });
        this.select_record_list();
      });
    }
  },
}
</script>

<style scoped>
.pass {
  background-color: rgba(36, 189, 120, 0.16);
  color: rgba(36, 189, 120, 1);
  border-color: rgba(36, 189, 120, 0);
}

.approving {
  background-color: rgba(10, 112, 245, 0.16);
  color: rgba(10, 112, 245, 1);;
  border-color: rgba(10, 112, 245, 0);
}

.rejected {
  background-color: rgba(255, 95, 87, 0.16);
  color: rgba(255, 95, 87, 1);
  border-color: rgba(255, 95, 87, 0);
}

.record-container {
  min-height: 100vh;
  background-color: #f7f7f7;
}

.card-container {
  padding: 8px;
  overflow-y: auto;
}

.card-item {
  padding: 16px 8px;
  background-color: white;
  margin-bottom: 8px;
  border-radius: 10px;
}

.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);;
}

.header-text {
  display: flex;
  height: 24px;
}

.record-id {
  margin-right: 12px;
}

.file-names {
  /*作为弹性伸缩盒子模型显示*/
  display: -webkit-box;
  /*显示的行数；如果要设置2行加...则设置为2*/
  -webkit-line-clamp: 1;
  overflow: hidden; /*超出的文本隐藏*/
  text-overflow: ellipsis; /* 溢出用省略号*/
  /*伸缩盒子的子元素排列：从上到下*/
  -webkit-box-orient: vertical;
  width: 65%;
  flex-grow: 1;
}

.record-id, .file-names {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 600;
}

.card-icon {
  font-size: 20px;
  align-items: center;
  line-height: 24px;
  margin-right: 6px;

}

.header-time {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  margin-top: 4px;
  margin-left: 26px;
  margin-bottom: 16px;
}

.record-detail {
  padding-top: 16px;
}

.record-detail .mtd-form-item-label, .out-link .mtd-form-item-label {
  text-align: left;
}

.record-detail .mtd-form-item, .out-link .mtd-form-item {
  margin-bottom: 10px;
}

.approval-btn {
  border-top: #f7f7f7 1px solid;
  padding: 16px 8px 0px 8px;
}

.validate_days_content {
  padding: 14px 16px;
  height: 270px;
}

.validate_days_content .mtd-radio {
  display: block;
  width: 100%;
  height: 22px;
  margin-bottom: 28px;
}

.validate_days_content .mtd-radio .custom-tips {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  letter-spacing: 0;
  font-weight: 400;
  line-height: 17px;
  margin-left: 24px;
}
</style>
